exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".product-deals-container .product-image{height:40px;width:40px;-o-object-fit:cover;object-fit:cover;border-radius:4px}.product-deal-item .text-truncate{text-overflow:ellipsis;overflow:hidden;max-width:178px;display:block}.product-deal-item{border-bottom:1px solid var(--border-color-1);font-size:14px;padding:10px 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-64ac2524","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/views/rd/assets/js/v2/components/shop/bestDeals.vue
// module id = 5dA4
// module chunks = 36